import { Pipe, PipeTransform } from '@angular/core';
import { ReferenceDataService } from '../services/reference-data.service';

@Pipe({ name: 'formatString' })
export class FormatStringPipe implements PipeTransform {
  transform(value: string, args: Array<any>): string {
    return ReferenceDataService.formatStringWithArguments(value, args);
  }
}

@Pipe({ name: 'removeWhiteSpaces' })
export class RemoveWhiteSpaces implements PipeTransform {
  transform(value: string): string {
    return value.replace(/\s/g, '');
  }
}

@Pipe({ name: 'replaceWithNewLine' })
export class ReplaceWithNewLine implements PipeTransform {
  transform(value: string): string {
    return value.replace(/;/g, '<br>');
  }
}

@Pipe({ name: 'formatNewLinesForInnerHtml' })
export class FormatNewLinesForInnerHtml implements PipeTransform {
  transform(value: string): string {
    return value.replace(/\n/g, '<br>');
  }
}
